<template lang="pug">
.padding
    h5._300.margin Zone
    
    .box
        v-server-table(
            ref="datatable" 
            :url="api" 
            :name="tableName" 
            :columns="columns" 
            :options="options"
        )

            template(slot="outlets" slot-scope="props")
                collection-counter(
                    label="name"
                    :subject="`${trans('general.outlets_assigned')}`"
                    :collection="props.row.outlets"
                )

    zone-form(ref="zoneForm")

</template>

<script>
import Auth from '@js/plugins/auth';
import zoneForm from './zone-form.vue';
import eventZone from './zone-event';
import CollectionCounter from '@js/components/collection-counter';

export default {
    components: {
        zoneForm,
        CollectionCounter,
    },
    data() {
        let canManageZone = Auth.hasPermissionTo('franchise_manage_zone');

        let actionButtons = [
            {
                title: 'Create Zone',
                action: () => {
                    this.showZone(null);
                },
            },
        ];

        if (!canManageZone) {
            actionButtons = [];
        }

        return {
            tableName: 'VUETABLE_ZONE',
            columns: ['name', 'outlets'],
            options: {
                checkbox: canManageZone,
                sortable: ['name'],

                rowClickCallback: row => {
                    this.showZone(row.id);
                },

                rowClassCallback: () => 'pointer',

                actionButtons: actionButtons,

                checkbox_actions: {
                    api_delete: Laroute.route('franchise.zone.delete'),
                    delete_title: 'Delete Zone',
                },

                headings: {
                    outlets: this.trans('general.outlets'),
                },
            },
        };
    },

    computed: {
        api() {
            return Laroute.route('franchise.zone.index');
        },
    },

    mounted() {
        this.registerEvent();
    },

    methods: {
        showZone(id) {
            this.$refs.zoneForm.$emit('show-zone', id);
        },

        registerEvent() {
            this.$refs.zoneForm.$on('zone-saved', () => {
                this.$refs.datatable.getData();
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/zone/zone-list.vue